import { useQuery } from 'react-query';

import { fetcher } from '../../client';
import { fetchContractList, fetchIncomingContractList } from '../../actions/contracts';

export function useContractList(params = {}) {
  return useQuery(["contracts", params], () => fetcher(fetchContractList(params)), {
    keepPreviousData: true
  });
}

export function useIncomingContractList(params = {}) {
  return useQuery(['incoming-contracts', params], () => fetcher(fetchIncomingContractList(params)), {
    refetchOnWindowFocus: false,
    keepPreviousData: true
  });
}
